import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type MetricMoverService from 'webapp/services/metric-mover';

export default class LegacyMetricMigrationIndexRoute extends Route {
	@service('metric-mover') declare metricMoverService: MetricMoverService;
	@service('navigation') declare navigationService: Service.Navigation;

	override queryParams = {
		spaceAccessId: { refreshModel: false },
	};

	override beforeModel(transition: Transition): void {
		const spaceAccessId = transition.to?.queryParams?.spaceAccessId as string | undefined;
		this.navigationService.transitionToRoute('datamanager');
		if (!this.metricMoverService.isMetricMoverAvailable) return;
		this.metricMoverService.open({ spaceAccessId });
	}
}
